import PropTypes from 'prop-types';
import React from 'react';

import {Polyline} from 'common/components/BetterMap';

const RidePath = ({pickup, dropoff}) => (
  <Polyline
    path={[pickup, dropoff]}
    strokeColor="#000"
    strokeWeight={12}
    icons = {[{
      icon: {
        path: 'M -3,2 0,-2 3,2',
        strokeOpacity: 1,
        strokeColor: 'white',
        strokeWeight: 1.5,
        scale: 1,
      },
      offset: '15px',
      repeat: '30px',
    }]}
  />
);

RidePath.propTypes = {
  pickup: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  }),
  dropoff: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  }),
};

export default RidePath;



// WEBPACK FOOTER //
// ./src/common/components/RidePath.js